module.exports = __webpack_public_path__ + "media/images/logos/bg-md-1455c60c37b6223aa370184ccfff3771.png";